import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, Plane, Instagram, Linkedin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-blue-950 via-blue-900 to-blue-800 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo & Beschrijving */}
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <img 
                src="/nikitas-logo.png" 
                alt="Nikita's Reizen op Maat" 
                className="h-16 w-auto"
              />
              <div className="flex flex-col">
                <span className="text-lg font-bold">Nikita's Reizen</span>
                <span className="text-sm text-blue-300">Op Maat</span>
              </div>
            </div>
            <p className="text-sm text-blue-200 leading-relaxed">
              Jouw specialist in unieke en persoonlijke reizen. Wij maken van elke reis een onvergetelijk avontuur.
            </p>
          </div>

          {/* Snelle Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Snelle Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-blue-200 hover:text-white transition-colors duration-300">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/over-ons" className="text-sm text-blue-200 hover:text-white transition-colors duration-300">
                  Over Ons
                </Link>
              </li>
              <li>
                <Link to="/diensten" className="text-sm text-blue-200 hover:text-white transition-colors duration-300">
                  Diensten
                </Link>
              </li>
              <li>
                <Link to="/maatwerkreizen" className="text-sm text-blue-200 hover:text-white transition-colors duration-300">
                  Maatwerkreizen
                </Link>
              </li>
              <li>
                <Link to="/rondreizen-tool" className="text-sm text-blue-200 hover:text-white transition-colors duration-300">
                  Rondreizen Tool
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-blue-300 mt-0.5 flex-shrink-0" />
                <a href="mailto:lemmensnikita@gmail.com" className="text-sm text-blue-200 hover:text-white transition-colors duration-300 break-all">Nikitasopmaatreizen@outlook.com

                </a>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-blue-300 flex-shrink-0" />
                <a href="tel:0624359764" className="text-sm text-blue-200 hover:text-white transition-colors duration-300">
                  06 243 597 64
                </a>
              </li>
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Volg Ons</h3>
            <div className="flex gap-3">
              <a
                href="https://www.instagram.com/nikitas_reizen"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 backdrop-blur-sm rounded-lg flex items-center justify-center hover:bg-white/20 transition-all duration-300 transform hover:scale-110"
                aria-label="Instagram">
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="https://www.linkedin.com/in/nikita-lemmens"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 backdrop-blur-sm rounded-lg flex items-center justify-center hover:bg-white/20 transition-all duration-300 transform hover:scale-110"
                aria-label="LinkedIn">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-white/10 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-blue-200">
              &copy; {currentYear} Nikita's Reizen op Maat. Alle rechten voorbehouden.
            </p>
            <div className="flex gap-4">
              <Link 
                to="/algemene-voorwaarden" 
                className="text-sm text-blue-200 hover:text-white transition-colors duration-300 underline"
              >
                Algemene Voorwaarden
              </Link>
              <Link 
                to="/privacy-policy" 
                className="text-sm text-blue-200 hover:text-white transition-colors duration-300 underline"
              >
                Privacy Policy
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>);

};

export default Footer;